import * as React from "react";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  disabled?: boolean;
};

export function Checkbox({ checked, onChange, label, disabled }: Props) {
  return (
    <label
      className={`group inline-flex select-none items-start gap-3 text-sm leading-normal text-primary ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="peer absolute h-0 w-0 opacity-0"
      />
      <span
        aria-hidden="true"
        className="relative mt-0.5 block h-[18px] w-[18px] flex-none border border-primary/30 bg-white transition-[border-color,background] duration-200 group-hover:border-primary peer-checked:border-primary peer-checked:bg-primary peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-primary/30 after:absolute after:left-1/2 after:top-[47%] after:hidden after:h-2.5 after:w-[5px] after:-translate-x-1/2 after:-translate-y-[55%] after:rotate-45 after:border-b-2 after:border-r-2 after:border-white after:content-[''] peer-checked:after:block"
      />
      <span>{label}</span>
    </label>
  );
}
